import React from 'react';
import { HIERARCHY_LABEL } from './hierarchyUtils';

/** Colour-coded level badge, shared by the tree and chart views. */
const HierarchyNodeBadge = ({ hierarchy }) => (
  <span className={`hierarchy-badge hierarchy-badge-${hierarchy?.toLowerCase()}`}>
    {HIERARCHY_LABEL[hierarchy] || hierarchy}
  </span>
);

export default HierarchyNodeBadge;
